import { render, staticRenderFns } from "./LeVue.vue?vue&type=template&id=2d1964f2&scoped=true&"
import script from "./LeVue.vue?vue&type=script&lang=js&"
export * from "./LeVue.vue?vue&type=script&lang=js&"
import style0 from "./LeVue.vue?vue&type=style&index=0&id=2d1964f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1964f2",
  null
  
)

export default component.exports